<template>
  <div class="vzanliveplayer-wrap">
    <video id="video-player"></video>
  </div>
</template>

<script>
import VzanLivePayer from 'vzanplayer'
import { getEnv } from '@/utils/utils'
export default {
  name: 'VzanLivePlayer',
  data() {
    return {}
  },
  methods: {
    updatesize() {
      document.documentElement.style.width = 'auto'
    },
  },
  unmounted() {
    window.removeEventListener('resize', this.updatesize)
  },
  mounted() {
    const appDom = document.querySelector('#app')
    appDom.style.maxWidth = 'none'
    document.documentElement.style.width = 'auto'
    window.addEventListener('resize', this.updatesize)
    const params = {
      playerType: 'common',
      type: this.$route.query.type,
      vid: this.$route.query.vid,
      liveId: this.$route.query.liveId,
      env: getEnv(),
    }
    const { width, height, autoplay, cover, loop, muted } = this.$route.query
    if (width) {
      params.width = width
    }
    if (height) {
      params.height = height
    }
    if (autoplay == 'true') {
      params.autoplay = true
    }
    if (cover) {
      params.cover = decodeURIComponent(cover)
    }
    if (loop == 'true') {
      params.loop = true
    }
    if (muted == 'true') {
      params.muted = true
    }
    window.vzplayer = new VzanLivePayer('video-player', params)
  },
}
</script>
<style scoped>
.vzanliveplayer-wrap {
  width: 100%;
  height: 100%;
}
</style>
